import { render, staticRenderFns } from "./DictionaryWordsNew.vue?vue&type=template&id=32e3a382&scoped=true&"
import script from "./DictionaryWordsNew.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsNew.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryWordsNew.vue?vue&type=style&index=0&id=32e3a382&lang=scss&scoped=true&"
import style1 from "./DictionaryWordsNew.vue?vue&type=style&index=1&id=32e3a382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3a382",
  null
  
)

export default component.exports